var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 69.018,
    height: 91.002,
    viewBox: "0 0 69.018 91.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_32398",
    x: 0,
    y: 0,
    width: 69.018,
    height: 91.002,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Path_32398)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32398-2",
    "data-name": "Path 32398",
    d: "M23.449-33.719A32.837,32.837,0,0,1,17.02-23.453a83.341,83.341,0,0,1-6.17,5.911Q6.858-14.017,2.4-10.44T-5.9-4.166H26.249V6.826H-24.769V-3.648q2.9-1.867,6.637-4.563t7.57-5.6q3.837-2.9,7.207-5.548t5.548-4.614Q13.08-33.823,13.08-43.156a11.41,11.41,0,0,0-3.94-9.229Q5.2-55.7-1.541-55.7A19.421,19.421,0,0,0-11.755-53.11a15.3,15.3,0,0,0-6.274,7.051q-6.429-1.97-6.429-6.429a8.047,8.047,0,0,1,.57-2.852,11.257,11.257,0,0,1,1.4-2.644q2.7-3.629,8.659-5.911A36.73,36.73,0,0,1-.608-66.176a32.678,32.678,0,0,1,13.9,2.748,21.8,21.8,0,0,1,9.177,7.622,19.645,19.645,0,0,1,3.266,11.2A29.309,29.309,0,0,1,23.449-33.719Z",
    transform: "translate(33.77 72.18)",
    fill: "#fcbf49"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumberIcon2);
export default __webpack_public_path__ + "static/media/number-icon2.4bde63330de7802959cd8c78d51c9cdf.svg";
export { ForwardRef as ReactComponent };